"use strict";
// views/facturation/factureForm
Object.defineProperty(exports, "__esModule", { value: true });
exports.factureForm = exports.factureLignesGrid = exports.formatNumeroFacture = void 0;
const globals_1 = require("models/globals");
const lists_1 = require("../../models/lists");
const tvaCell_1 = require("./tvaCell");
exports.formatNumeroFacture = [
    { "id": 1, "value": (0, globals_1._)("Numéro uniquement") + " : NNNN" },
    { "id": 2, "value": (0, globals_1._)("Année et numéro") + " : AAAA-NNNN" },
    { "id": 3, "value": (0, globals_1._)("Année, mois et numéro") + " : AAAA-MM-NNNN" },
    { "id": 4, "value": (0, globals_1._)("Numéro uniquement") + " : NNNNNN" },
    { "id": 5, "value": (0, globals_1._)("Année et numéro") + " : AAAA-NNNNNN" },
    { "id": 6, "value": (0, globals_1._)("Année, mois et numéro") + " : AAAA-MM-NNNNNN" }
];
exports.factureLignesGrid = [
    // {id : "unid", header : _("N°"), sort : "int",css : {"text-align" : "right"}, adjust : true},
    { id: "idDocument", header: (0, globals_1._)("N° document"), adjust: true, hidden: true },
    { id: "idTypeDocument", header: (0, globals_1._)("Type"), adjust: true, hidden: true },
    { id: "drag", header: "", template: "<div class='webix_drag_handle'></div>", width: 35 },
    { id: "codeArticle", header: (0, globals_1._)("Code"), adjust: true, maxlength: 12, editor: "text" },
    { id: "designation", editor: "popup", header: (0, globals_1._)("Désignation"), fillspace: true, attributes: { maxLength: 250 },
        width: 420, height: 120 },
    { id: "prixVente", editor: "text", header: (0, globals_1._)("Prix Vente"), adjust: true, css: { "text-align": "right" },
        maxlength: 11, minWidth: globals_1.lv2.ihm.documentColumnMinWidth,
        format: function (value) {
            return webix.i18n.numberFormat(value);
        } },
    { id: "remiseLigne", editor: "text", header: (0, globals_1._)("Remise_%"), adjust: true, css: { "text-align": "right" } },
    { id: "idTypeRemiseLigne", header: (0, globals_1._)("Type"), adjust: true, hidden: true },
    { id: "prixNet", header: (0, globals_1._)("Prix Net"), adjust: true, css: { "text-align": "right" },
        maxlength: 11, minWidth: globals_1.lv2.ihm.documentColumnMinWidth,
        format: function (value) {
            return webix.i18n.numberFormat(value);
        } },
    { id: "quantite", editor: "text", header: (0, globals_1._)("Quantité"), adjust: true, css: { "text-align": "right" },
        format: function (value) {
            if (value == "")
                return "";
            if (Number.parseInt(value) == Number.parseFloat(value)) {
                return Number.parseInt(value);
            }
            else {
                return Number.parseFloat(value);
            }
        }
    },
    { id: "numLigne", header: (0, globals_1._)("N° ligne"), adjust: true, hidden: true },
    { id: "totalLigne", header: (0, globals_1._)("Total"), adjust: true, css: { "text-align": "right" },
        minWidth: globals_1.lv2.ihm.documentColumnMinWidth,
        format: function (value) {
            return webix.i18n.numberFormat(value);
        } },
    { id: "prixNetNet", header: (0, globals_1._)("Prix Net Net"), adjust: true, hidden: true },
    { id: "idTVA", header: (0, globals_1._)("Code TVA"), width: "120", editor: "select", adjust: true,
        options: lists_1.tvaList, sort: "text" },
    // {id : "idTVA", editor : "text", header : _("TVA") , adjust : true},
    { id: "idClient", header: (0, globals_1._)("Client"), adjust: true, hidden: true }
];
exports.factureForm = {
    view: "form",
    id: "factureFormId",
    libelle: "Facture / Avoir",
    autocomplete: "off",
    scroll: true,
    margin: 2,
    elementsConfig: { maxWidth: 500, labelAlign: "right", labelWidth: 100,
        on: { onChange: function (newValue) { globals_1.lv2.clean(newValue, this); } }
    },
    elements: [
        {
            view: "text",
            name: "idTypeDocument",
            localId: "idTypeDocument",
            hidden: true
        }, {
            view: "text",
            name: "unid",
            id: "idDocument",
            hidden: true
        }, {
            view: "text",
            name: "factureValide",
            localId: "factureValide",
            hidden: true
        }, {
            view: "text",
            name: "idClient",
            localId: "idClient",
            hidden: true
        }, {
            cols: [{
                    view: "label",
                    label: "Document",
                    name: "typeDocument",
                    localId: "typeDocument",
                    css: "typeDoc",
                    width: "120"
                }, {
                    view: "text",
                    name: "numeroDocument",
                    localId: "numeroDocument",
                    label: (0, globals_1._)("N°"),
                    width: "250",
                    readonly: true,
                    tooltip: "Ce champ n'est pas modifiable"
                }, {
                    view: "datepicker",
                    name: "dateDocument",
                    localId: "dateDocument",
                    invalidMessage: (0, globals_1._)("La date est obligatoire"),
                    label: (0, globals_1._)("Date"),
                    width: "240",
                    editor: "datepicker"
                }]
        }, {
            cols: [{
                    view: "text",
                    name: "codeClient",
                    localId: "codeClient",
                    label: (0, globals_1._)("Code client"),
                    width: "250",
                    attributes: { maxlength: 8 },
                    // editor : "text"
                }, {
                    id: "rechercherClientDocument", "view": "button", width: "32",
                    type: "icon", icon: "mdi mdi-table-search"
                }, {
                    view: "checkbox",
                    name: "comptePro",
                    localId: "comptePro",
                    label: (0, globals_1._)("Professionnel"),
                    editor: "checkbox"
                }]
        }, {
            cols: [{
                    view: "text",
                    name: "adresseNom",
                    localId: "adresseNom",
                    label: (0, globals_1._)("Nom"),
                    width: "400",
                    attributes: { maxlength: 40 },
                    editor: "text"
                }]
        }, {
            cols: [{
                    view: "text",
                    name: "adresseSuite",
                    localId: "adresseSuite",
                    label: (0, globals_1._)("Adresse"),
                    width: "400",
                    attributes: { maxlength: 40 },
                    editor: "text"
                }]
        }, {
            cols: [{
                    view: "text",
                    name: "adresseRue",
                    localId: "adresseRue",
                    label: (0, globals_1._)("N° et rue"),
                    width: "400",
                    attributes: { maxlength: 40 },
                    editor: "text"
                }]
        }, {
            cols: [{
                    view: "text",
                    name: "adresseCP",
                    localId: "adresseCP",
                    label: (0, globals_1._)("Code Postal"),
                    width: "180",
                    attributes: { maxlength: 5 },
                    editor: "text"
                }, {
                    view: "text",
                    name: "adresseVille",
                    localId: "adresseVille",
                    label: (0, globals_1._)("Ville"),
                    labelWidth: 60,
                    width: "400",
                    attributes: { maxlength: 34 },
                    editor: "text"
                }]
        }, {
            cols: [{
                    view: "text",
                    name: "pays",
                    localId: "pays",
                    label: (0, globals_1._)("Pays"),
                    width: "300",
                    attributes: { maxlength: 24 },
                    editor: "text"
                }]
        }, {
            cols: [{
                    view: "text",
                    name: "modeReglement",
                    localId: "modeReglement",
                    label: (0, globals_1._)("Règlement"),
                    width: "400",
                    attributes: { maxlength: 40 },
                    editor: "text"
                }]
        }, {
            cols: [{
                    view: "text",
                    name: "numTVA",
                    localId: "numTVA",
                    label: (0, globals_1._)("Numéro TVA"),
                    width: "240",
                    attributes: { maxlength: 15 },
                    editor: "text"
                }]
        }, {
            cols: [{
                    view: "text",
                    name: "compteCompta",
                    id: "compteCompta",
                    label: (0, globals_1._)("Comptabilité"),
                    width: "250",
                    attributes: { maxlength: 12 },
                    tooltip: (0, globals_1._)("N° du compte comptable"),
                    editor: "text"
                }]
        }, {
            cols: [{
                    view: "text",
                    name: "noteFacture",
                    localId: "noteFacture",
                    id: "factureFormLastField",
                    label: (0, globals_1._)("Note document"),
                    width: "600",
                    attributes: { maxlength: 80 },
                    editor: "text"
                }]
        },
        { rows: tvaCell_1.tvaCell, id: "tvaCell", hidden: false },
        { rows: tvaCell_1.ttcCell, id: "ttcCell", hidden: true }
    ],
    rules: {
        // @ts-ignore
        "dateDocument": webix.isDate
    }
};
